import SettingIcon from '@rsuite/icons/Setting';
import {
  Button,
  Checkbox,
  CheckboxGroup,
  Divider,
  IconButton,
  Popover,
  Whisper,
} from 'rsuite';
import styled from 'styled-components';

const StyledPopover = styled(Popover)`
  width: 380px;
  padding: 20px;
  font-size: 14px;
  color: #333;
`;

const StyledCheckboxGroup = styled(CheckboxGroup)`
  display: flex;
  justify-content: space-between;
  margin-left: -10px;
  margin-top: 10px;
`;

function CheckboxColumn({ items }) {
  return (
    <div>
      {items.map(({ label, columnId }) => (
        <Checkbox
          data-cy={`checkbox-${columnId}`}
          key={columnId}
          value={columnId}
        >
          {label}
        </Checkbox>
      ))}
    </div>
  );
}

// TODO: Column ids should not be magic strings. Use them from col dev instance

/**
 * This component renders a popover panel that provides the user with checkboxes in order
 * to select which columns should be visible
 *
 * @param {string[]} props.displayedColumns ColId's of ag-grid columns that should be checked
 * @param {func} props.onChangeCB
 */
export function ColumnPickerPopover({
  displayedColumns,
  onColPickerChangeCB,
  onColumnsReset,
}) {
  const renderSpeaker = (props, ref) => {
    const { onClose } = props;

    return (
      <StyledPopover {...props} ref={ref}>
        <div>
          <div css="font-size: 14px;">Display Columns</div>
          <StyledCheckboxGroup
            onChange={(values) => {
              onColPickerChangeCB(values);
            }}
            value={displayedColumns}
          >
            <CheckboxColumn
              items={[
                { label: 'Date/Time Raised', columnId: 'submissionDate' },
                { label: 'Complaint #', columnId: 'complaintId' },
                { label: 'Status', columnId: 'status' },
                { label: 'Complaint Type', columnId: 'complaintTypes' },
                { label: 'Property Address', columnId: 'streetAddress' },
                { label: 'Complaint Description', columnId: 'description' },
              ]}
            />
            <CheckboxColumn
              items={[
                { label: 'Complainant Name', columnId: 'contactFirstName' },
                { label: 'Complainant Phone', columnId: 'contactPhone' },
                { label: 'Complainant Email', columnId: 'contactEmail' },
              ]}
            />
          </StyledCheckboxGroup>
        </div>
        <Divider style={{ margin: '20px 0' }} />
        <div>
          <div css="display: flex; justify-content: space-between;">
            <Button appearance="subtle" onClick={onColumnsReset}>
              Reset to default
            </Button>
            <Button appearance="primary" onClick={onClose}>
              Close
            </Button>
          </div>
        </div>
      </StyledPopover>
    );
  };

  return (
    <Whisper
      placement="bottomEnd"
      trigger="click"
      controlId="control-id-click"
      speaker={renderSpeaker}
    >
      <IconButton
        data-cy="complaints-column-picker-popover"
        icon={<SettingIcon />}
      >
        Columns
      </IconButton>
    </Whisper>
  );
}
